module.exports = __webpack_public_path__ + "img/VA4.139f6d43.jpeg";